import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { updateStatus } from 'actions/campaign/addOrEdit'
import { Fab, withStyles, Tooltip } from '@material-ui/core'
import { PlayArrow, Pause } from '@material-ui/icons'
import language from 'utils/vast-languagepack'

export default connect(
  state => ({ status: state.campaign.addOrEdit.campaign.status }),
  dispatch => bindActionCreators({ updateStatus }, dispatch),
)(
  withStyles(theme => ({
    floatingActionButton: {
      // position: 'fixed',
      // bottom: '23px',
      // right: '23px',
      color: '#fff',
      // [theme.breakpoints.down('sm')]: {
      //   bottom: '75px',
      // },
    },
  }))(({ classes, updateStatus, status, size, style }) => {
    return (
      <Tooltip title={status === 'L' ? language.campaign.campaignStatus.pauseButton : language.campaign.campaignStatus.goLiveButton}>
        <Fab
          style={style || null}
          disabled={!status || status === 'C'}
          className={classes.floatingActionButton}
          color="secondary"
          onClick={() => updateStatus(status)}
          size={size || 'large'}
        >
          {status === 'L' ? <Pause /> : <PlayArrow />}
        </Fab>
      </Tooltip>
    )
  }),
)
